import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function CtaBanner() {
  return (
    <section className="bg-brand-light py-14 lg:py-16">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="rounded-2xl bg-brand text-white px-8 py-10 lg:px-12 lg:py-12 flex flex-col lg:flex-row items-center justify-between gap-6 shadow-[0_20px_50px_rgba(30,95,180,0.30)]">
            <div className="text-center lg:text-left">
              <h3 className="font-extrabold tracking-tight text-2xl sm:text-3xl">
                Kazanmaya bugün başlayın
              </h3>
              <p className="text-white/80 mt-2 max-w-xl">
                Ücretsiz kayıt olun, danışmanlarımız sizi bilgilendirsin. Fırsatları kaçırmayın.
              </p>
            </div>
            <a
              href="#kayit"
              data-testid="cta-banner-register"
              className="shrink-0 inline-flex items-center gap-2 rounded-md bg-white px-8 py-4 text-brand font-bold tracking-wide transition-all duration-300 hover:bg-gold hover:text-navy-deep hover:-translate-y-0.5"
            >
              HEMEN KAYIT OL
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
